import { AffiliationType, LocationPreference } from '@/api/apis/resources';
import { SelectItemType } from '@/types';

export const CONTRACTOR_LOCATION_PREFERENCES: SelectItemType[] = [
  { value: LocationPreference.Base, name: 'Base' },
  { value: LocationPreference.Home, name: 'Home' },
  { value: LocationPreference.Affiliation, name: 'Affiliation' },
];

export const CONTRACTOR_AFFILIATION_PREFERENCES: SelectItemType[] = [
  { value: AffiliationType.TMDXContract, name: 'TMDX Contract' },
  { value: AffiliationType.TXCenter, name: 'TX Center' },
  { value: AffiliationType.OPO, name: 'OPO' },
  { value: AffiliationType.NoContract, name: 'No Contract' },
];
